import { useState } from "react"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { AuthLayout } from "@/components/auth/AuthLayout"
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm"

export function ResetPasswordScreen() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [done, setDone] = useState(false)
  const token = searchParams.get("token")

  if (!token) {
    return (
      <AuthLayout>
        <div className="w-full max-w-md text-center">
          <h2 className="mb-2 text-3xl font-bold tracking-tight text-foreground">Invalid Link</h2>
          <p className="mb-8 text-muted-foreground">
            This reset link is invalid or has expired.
          </p>
          <Link
            to="/forgot-password"
            className="inline-flex h-12 items-center justify-center rounded-xl bg-primary px-6 text-sm font-bold text-primary-foreground shadow-md shadow-primary/20 transition-opacity hover:opacity-90"
          >
            Request New Link
          </Link>
        </div>
      </AuthLayout>
    )
  }

  if (done) {
    return (
      <AuthLayout>
        <div className="w-full max-w-md text-center">
          <h2 className="mb-2 text-3xl font-bold tracking-tight text-foreground">Password Reset</h2>
          <p className="mb-8 text-muted-foreground">
            Your password has been updated. You can now sign in with the new credentials.
          </p>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="inline-flex h-12 items-center justify-center rounded-xl bg-primary px-6 text-sm font-bold text-primary-foreground shadow-md shadow-primary/20 transition-opacity hover:opacity-90"
          >
            Continue to Sign In
          </button>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout>
      <div className="w-full max-w-md">
        <div className="animate-in fade-in slide-in-from-right-5 duration-500 ease-out">
          <header className="mb-10 text-center lg:text-left">
            <h2 className="mb-2 text-3xl font-bold tracking-tight text-foreground">
              Set New Password
            </h2>
            <p className="text-muted-foreground">
              Choose a new password for your operator profile.
            </p>
          </header>

          <ResetPasswordForm token={token} onSuccess={() => setDone(true)} />
        </div>

        <p className="mt-8 text-center">
          <Link
            to="/"
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Back to sign in
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}
